export const domainsByCountryCode = {
  ae: 'miele.ae',
  at: 'miele.at',
  au: 'miele.com.au',
  be: 'miele.be',
  bg: 'miele.bg',
  br: 'mielebrasil.com.br',
  ca: 'miele.ca',
  ch: 'miele.ch',
  cl: 'miele.cl',
  cn: 'miele.cn',
  com: 'miele.com', // corporate domain
  cz: 'miele.cz',
  de: 'miele.de',
  dk: 'miele.dk',
  ee: 'miele.ee',
  es: 'miele.es',
  fi: 'miele.fi',
  fr: 'miele.fr',
  gr: 'miele.gr',
  hk: 'miele.hk',
  hr: 'miele.hr',
  hu: 'miele.hu',
  ie: 'miele.ie',
  in: 'miele.in',
  it: 'miele.it',
  jp: 'miele.jp',
  kr: 'miele.co.kr',
  kz: 'miele.kz',
  lt: 'miele.lt',
  lu: 'miele.lu',
  lv: 'miele.lv',
  mx: 'miele.com.mx',
  my: 'miele.my',
  nl: 'miele.nl',
  no: 'miele.no',
  nz: 'miele.co.nz',
  pl: 'miele.pl',
  pt: 'miele.pt',
  ro: 'miele.ro',
  rs: 'miele.rs',
  ru: 'miele.ru',
  se: 'miele.se',
  sg: 'miele.sg',
  sk: 'miele.sk',
  sl: 'miele.sl',
  tr: 'miele.com.tr',
  th: 'miele.co.th',
  ua: 'miele.ua',
  uk: 'miele.co.uk',
  us: 'mieleusa.com',
  za: 'miele.co.za',
} as const

export const countryCodeLanguageMap = [
  { countryCode: 'be', languages: ['nl', 'fr'] },
  { countryCode: 'ca', languages: ['en', 'fr'] },
  { countryCode: 'ch', languages: ['de', 'fr', 'it'] },
  { countryCode: 'com', languages: ['en', 'de'] }, // corporate domain
  { countryCode: 'hk', languages: ['en', 'zh'] },
  { countryCode: 'kz', languages: ['kk', 'ru'] },
  { countryCode: 'lu', languages: ['fr', 'de'] },
]

export type SUPPORTED_COUNTRIES_ISO_ALPHA2 = keyof typeof domainsByCountryCode
